import React from 'react';

interface GiftProgressBarProps {
  /** 0..1 */
  progress: number;
}

/**
 * Linear progress bar for the GiftCard. Sempre verde, sem gradiente.
 * Uses Tailwind tokens only — no MUI, no external chart libs.
 */
const GiftProgressBar: React.FC<GiftProgressBarProps> = ({ progress }) => {
  const pct = Math.round(Math.min(1, Math.max(0, progress)) * 100);

  return (
    <div className="relative h-1.5 w-full overflow-hidden rounded-full bg-gray-200 dark:bg-gray-700">
      <div
        className="h-full rounded-full bg-emerald-500 transition-[width] duration-300 ease-out"
        style={{ width: `${pct}%` }}
      />
    </div>
  );
};

export default GiftProgressBar;
